/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetIssuableStatus200ResponseIssuableCardsInner
 */
export interface GetIssuableStatus200ResponseIssuableCardsInner {
    /**
     * 
     * @type {string}
     * @memberof GetIssuableStatus200ResponseIssuableCardsInner
     */
    'type'?: GetIssuableStatus200ResponseIssuableCardsInnerTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetIssuableStatus200ResponseIssuableCardsInner
     */
    'limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetIssuableStatus200ResponseIssuableCardsInner
     */
    'activeCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetIssuableStatus200ResponseIssuableCardsInner
     */
    'issuableCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetIssuableStatus200ResponseIssuableCardsInner
     */
    'issuable'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetIssuableStatus200ResponseIssuableCardsInner
     */
    'reason'?: Array<string>;
}

export const GetIssuableStatus200ResponseIssuableCardsInnerTypeEnum = {
    virtualCard: 'VIRTUAL_CARD',
    virtualCardOnDemand: 'VIRTUAL_CARD_ON_DEMAND',
    physicalCard: 'PHYSICAL_CARD',
    physicalCardMetal: 'PHYSICAL_CARD_METAL',
    etcCard: 'ETC_CARD'
} as const;

export type GetIssuableStatus200ResponseIssuableCardsInnerTypeEnum = typeof GetIssuableStatus200ResponseIssuableCardsInnerTypeEnum[keyof typeof GetIssuableStatus200ResponseIssuableCardsInnerTypeEnum];


